import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'

import { CruiseContentSections, CRUISE_CONTENT_SECTION_LABELS } from 'constants/cruise'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import Heading from 'LuxKit/Typography/Heading'
import CruiseItineraryAndMap from './CruiseItineraryAndMap'
import Group from 'components/utils/Group'

const SectionContainer = styled.div`
  padding: ${rem(32)} 0;
`

interface Props {
  itinerary?: Array<App.CruiseItineraryItem>
  cruiseType: App.CruiseType
}

function CruiseOfferPageItinerary({
  itinerary,
  cruiseType,
}: Props) {
  return <Pane>
    <LayoutContainer>
      <SectionContainer>
        <Group direction="vertical" gap={32}>
          <Heading
            align="center"
            variant="heading2"
            className="section-title"
          >
            {CRUISE_CONTENT_SECTION_LABELS[CruiseContentSections.ITINERARY]}
          </Heading>
          <div className="section-content">
            {itinerary && <CruiseItineraryAndMap itinerary={itinerary} cruiseType={cruiseType} />}
          </div>
        </Group>
      </SectionContainer>
    </LayoutContainer>
  </Pane>
}

export default CruiseOfferPageItinerary
